/** Passe à `true` quand l'app est publiée sur le store correspondant. */
export const appStoreAvailable = false;
export const googlePlayStore = false;

export const STORE_URLS = {
  safetizen: {
    playStore: 'https://play.google.com/store/apps/details?id=com.safetizen.placeholder',
    appStore: 'https://apps.apple.com/app/id0000000000',
  },
  earit: {
    playStore: 'https://play.google.com/store/apps/details?id=com.earit.placeholder',
    appStore: 'https://apps.apple.com/app/id0000000000',
  },
} as const;

export type StoreApp = keyof typeof STORE_URLS;
